import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { ButtonIcon, TopMenu } from "../../components";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Spin } from "antd";
import { verifyEmail } from "../AdsSignUp/services/adsSignup.service";
import {
  decodedToken,
  isLoginAds,
  setAdsSession,
  setUserSession,
} from "../../utils";
import { LoadingOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { setAdsUserDetails } from "../AdsPlatform/redux/actions";
import { FaRegCheckCircle } from "react-icons/fa";
import { setNewsUser } from "../console/redux/actions";

const AdsVerifyEmail = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(null);
  const dispatch = useDispatch();

  async function fetchUserVerification() {
    let param = window.location.pathname;
    param = param.split("ads/verify-email=");
    console.log({ param });
    if (param && param[1]) {
      const token = param[1];
      let adsSession = isLoginAds();
      if (!adsSession) {
        setAdsSession(token);
      }
      let company = await decodedToken(token);

      let body = {
        token: token,
        company_id: company?.company_id,
      };
      try {
        let res = await verifyEmail(body);
        console.log(res);
        if (res?.data?.status) {
          setIsLoading(false);
          console.log("res", res.data.data);
          setAdsSession(res.data.data?.token);
          dispatch(setAdsUserDetails(res.data.data?.user));
          if (res.data.data?.user?.company_type !== "publisher") {
            dispatch(setNewsUser(res.data.data?.user));
            setUserSession(res.data.data?.token);
          }
          setIsVerified(true);
          setTimeout(() => {
            if (res.data.data?.user?.company_type === "publisher") {
              props.history.push(`/ads/campaign`);
            } else {
              props.history.push(`/`);
            }
          }, 6000);
        } else {
          setIsLoading(false);
          setIsVerified(false);
        }
      } catch (error) {
        console.log({ error });
        setIsLoading(false);
        setIsVerified(false);
      }
    }
  }

  useEffect(() => {
    setIsLoading(true);
    fetchUserVerification();
  }, []);

  return (
    <>
      <div className={"ads-verify-email-wrapper"}>
        <div>
          <TopMenu
            data={{
              size: "sm",
              isLanguage: false,
              isLogo: false,
              isProfile: false,
            }}
          />
        </div>
        <div className={"avw__main-wrp"}>
          <div className={"avw__nagivator"}>
            <ButtonIcon
              data={{
                iconName: "h-wrrow-left",
                size: "md",
                type: "light",
              }}
              onClick={() => {
                props.history.push("/ads");
              }}
            />
            Back to home
          </div>
          <div className={"avw__form"}>
            <div className={"adve__header-wrapper"}>
              <div className={"adve__hw-logo"}>
                <img
                  src={require("../../assets/img/logo_new.png")}
                  alt={"logo"}
                />
              </div>
            </div>
            {/* <div className={"adve__loading"}> */}
            <Spin
              spinning={isLoading}
              indicator={
                <LoadingOutlined
                  style={{ fontSize: 48, color: "#FA1C69" }}
                  spin
                />
              }
            />
            {/* </div> */}
            <div className={"adve__content"}>
              {!isLoading && (
                <div className="adve__success-icon">
                  <FaRegCheckCircle />
                </div>
              )}
              <span>
                {isLoading && !isVerified
                  ? "Please wait. your request is being processed"
                  : "Thank you! Your email has been verified successfully. You will be redirected shortly."}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(AdsVerifyEmail);
